import { Routes } from "../../Routes";

export function getActiveCourseIdFromPath(pathname: string): string | null {
  const prefix = `${Routes.Educations}/`;
  if (!pathname.startsWith(prefix)) {
    return null;
  }

  const courseId = pathname.slice(prefix.length).split("/")[0];
  return courseId || null;
}

type SidebarCourseFocusInput = {
  pathname: string;
  courseId: string;
  selectedCourseId: string | null | undefined;
  isCertificateSection: boolean;
};

export function isSidebarCourseItemFocused({
  pathname,
  courseId,
  selectedCourseId,
  isCertificateSection,
}: SidebarCourseFocusInput): boolean {
  const activeCourseId = getActiveCourseIdFromPath(pathname);
  const isCertificateRoute = pathname.includes(`/${Routes.Certificate}`);

  if (isCertificateSection) {
    return activeCourseId === courseId && isCertificateRoute;
  }

  if (selectedCourseId !== courseId) {
    return false;
  }

  if (pathname === Routes.Educations) {
    return true;
  }

  return activeCourseId === courseId && !isCertificateRoute;
}
